import React from 'react';
import './calendarCells.scss';

// This component is the back of the calendar that shows all the calendar cells.
// All of these divs are positioned with CSS Grid

function CalendarCells() {
  return (
    <div className="full-cal-cell-background">
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
      <div className="full-cal-cell"></div>
    </div>
  );
}

export default CalendarCells;
